module.exports = __webpack_public_path__ + "static/media/shop.7c457dea.svg";